import React, {Component} from "react";
import ACTIONS from "../constants/actions";
import {connect} from "react-redux";
import PropTypes from "prop-types";

class Favorite extends Component {
	static defaultProps = {
		type           : 1,
		isFavoriteLink : false,
	};

	static propTypes = {
		type           : PropTypes.number,
		isFavoriteLink : PropTypes.bool,
	};

	toggleFavorite(data) {
		this.props.toggleFavorite(data);
	}

	render() {
		const {eventId, favorites, type, isFavoriteLink} = this.props;
		const isFavorite = favorites.indexOf(eventId) !== -1;
		const cls = type === 1 ? 'stars' : 'stars-2';

		if ( isFavoriteLink ) {
			return (
				<span className={`stars ${favorites.length > 0 && 'activated'}`}></span>
			);
		}

		return (
			<span className={`${cls} ${isFavorite && 'activated'}`} onClick={this.toggleFavorite.bind(this, eventId)}></span>
		);
	}
}

export default connect(
	state => ({
		favorites : state.favorites
	}),
	dispatch => ({
		toggleFavorite : (data) => {
			dispatch({type : ACTIONS.FAVORITES.TOGGLE, data : data})
		},
	})
)(Favorite);


// WEBPACK FOOTER //
// ./src/app/components/Favorite.js